// Generated by protoc-gen-vendasta-ts — DO NOT EDIT
/* eslint-disable */
import { defer } from 'rxjs';
import { map } from 'rxjs/operators';
import { createPhoneProvisioningInfoRequestToJson, createPhoneProvisioningInfoResponseFromJson, getMultiPhoneProvisioningInfoRequestToJson, getMultiPhoneProvisioningInfoResponseFromJson, listPhoneProvisioningInfoRequestToJson, listPhoneProvisioningInfoResponseFromJson, updatePhoneProvisioningInfoRequestToJson } from './codec';
import { fetchRpc } from '@vendasta/protos/fetch-transport';
import { getGlobalTransport } from '@vendasta/protos/transport';
export async function getMultiPhoneProvisioningInfo(request) {
    const raw = await fetchRpc('sms.v2.PhoneProvisioning/GetMultiPhoneProvisioningInfo', getMultiPhoneProvisioningInfoRequestToJson(request));
    return getMultiPhoneProvisioningInfoResponseFromJson(raw);
}
export function getMultiPhoneProvisioningInfo$(request, options) {
    return defer(() => getMultiPhoneProvisioningInfoWithTransport$(getGlobalTransport(), request, options));
}
export function getMultiPhoneProvisioningInfoWithTransport$(transport, request, options) {
    return transport
        .post('sms.v2.PhoneProvisioning/GetMultiPhoneProvisioningInfo', getMultiPhoneProvisioningInfoRequestToJson(request), options)
        .pipe(map(resp => getMultiPhoneProvisioningInfoResponseFromJson(resp)));
}
export async function listPhoneProvisioningInfo(request) {
    const raw = await fetchRpc('sms.v2.PhoneProvisioning/ListPhoneProvisioningInfo', listPhoneProvisioningInfoRequestToJson(request));
    return listPhoneProvisioningInfoResponseFromJson(raw);
}
export function listPhoneProvisioningInfo$(request, options) {
    return defer(() => listPhoneProvisioningInfoWithTransport$(getGlobalTransport(), request, options));
}
export function listPhoneProvisioningInfoWithTransport$(transport, request, options) {
    return transport
        .post('sms.v2.PhoneProvisioning/ListPhoneProvisioningInfo', listPhoneProvisioningInfoRequestToJson(request), options)
        .pipe(map(resp => listPhoneProvisioningInfoResponseFromJson(resp)));
}
export async function createPhoneProvisioningInfo(request) {
    const raw = await fetchRpc('sms.v2.PhoneProvisioning/CreatePhoneProvisioningInfo', createPhoneProvisioningInfoRequestToJson(request));
    return createPhoneProvisioningInfoResponseFromJson(raw);
}
export function createPhoneProvisioningInfo$(request, options) {
    return defer(() => createPhoneProvisioningInfoWithTransport$(getGlobalTransport(), request, options));
}
export function createPhoneProvisioningInfoWithTransport$(transport, request, options) {
    return transport
        .post('sms.v2.PhoneProvisioning/CreatePhoneProvisioningInfo', createPhoneProvisioningInfoRequestToJson(request), options)
        .pipe(map(resp => createPhoneProvisioningInfoResponseFromJson(resp)));
}
export async function updatePhoneProvisioningInfo(request) {
    await fetchRpc('sms.v2.PhoneProvisioning/UpdatePhoneProvisioningInfo', updatePhoneProvisioningInfoRequestToJson(request));
}
export function updatePhoneProvisioningInfo$(request, options) {
    return defer(() => updatePhoneProvisioningInfoWithTransport$(getGlobalTransport(), request, options));
}
export function updatePhoneProvisioningInfoWithTransport$(transport, request, options) {
    return transport
        .post('sms.v2.PhoneProvisioning/UpdatePhoneProvisioningInfo', updatePhoneProvisioningInfoRequestToJson(request), options)
        .pipe(map(() => undefined));
}
